// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
.nkl-text-primary {
  color: #1890ff !important;
}
.nkl-text-secondary {
  color: rgba(0, 0, 0, 0.45) !important;
}
.nkl-text-success {
  color: #52c41a !important;
}
.nkl-text-processing {
  color: #1890ff !important;
}
.nkl-text-error,
.nkl-text-danger {
  color: #ff4d4f !important;
}
.nkl-text-warning {
  color: #faad14 !important;
}
.nkl-text-info {
  color: #1890ff !important;
}
.nkl-text-light {
  color: #d9d9d9 !important;
}
.nkl-text-white {
  color: #fff !important;
}
.nkl-text-dark {
  color: #000 !important;
}
.nkl-bg-primary {
  background-color: #1890ff !important;
}
.nkl-bg-secondary {
  background-color: rgba(0, 0, 0, 0.45) !important;
}
.nkl-bg-success {
  background-color: #52c41a !important;
}
.nkl-bg-processing {
  background-color: #1890ff !important;
}
.nkl-bg-error,
.nkl-bg-danger {
  background-color: #ff4d4f !important;
}
.nkl-bg-warning {
  background-color: #faad14 !important;
}
.nkl-bg-info {
  background-color: #1890ff !important;
}
.nkl-bg-light {
  background-color: #d9d9d9 !important;
}
.nkl-bg-white {
  background-color: #fff !important;
}
.nkl-bg-dark {
  background-color: #001529 !important;
}
.nkl-position-static {
  position: static   !important;
}
.nkl-position-relative {
  position: relative !important;
}
.nkl-position-absolute {
  position: absolute !important;
}
.nkl-position-fixed {
  position: fixed    !important;
}
.nkl-position-sticky {
  position: sticky   !important;
}
.nkl-m-5 {
  margin: 24px !important;
}
.nkl-mt-5 {
  margin-top: 24px !important;
}
.nkl-mb-5 {
  margin-bottom: 24px !important;
}
.nkl-ml-5 {
  margin-left: 24px !important;
}
.nkl-mr-5 {
  margin-right: 24px !important;
}
.nkl-mx-5 {
  margin-left: 24px !important;
  margin-right: 24px !important;
}
.nkl-my-5 {
  margin-top: 24px !important;
  margin-bottom: 24px !important;
}
.nkl-m-4 {
  margin: 16px !important;
}
.nkl-mt-4 {
  margin-top: 16px !important;
}
.nkl-mb-4 {
  margin-bottom: 16px !important;
}
.nkl-ml-4 {
  margin-left: 16px !important;
}
.nkl-mr-4 {
  margin-right: 16px !important;
}
.nkl-mx-4 {
  margin-left: 16px !important;
  margin-right: 16px !important;
}
.nkl-my-4 {
  margin-top: 16px !important;
  margin-bottom: 16px !important;
}
.nkl-m-3 {
  margin: 12px !important;
}
.nkl-mt-3 {
  margin-top: 12px !important;
}
.nkl-mb-3 {
  margin-bottom: 12px !important;
}
.nkl-ml-3 {
  margin-left: 12px !important;
}
.nkl-mr-3 {
  margin-right: 12px !important;
}
.nkl-mx-3 {
  margin-left: 12px !important;
  margin-right: 12px !important;
}
.nkl-my-3 {
  margin-top: 12px !important;
  margin-bottom: 12px !important;
}
.nkl-m-2 {
  margin: 8px !important;
}
.nkl-mt-2 {
  margin-top: 8px !important;
}
.nkl-mb-2 {
  margin-bottom: 8px !important;
}
.nkl-ml-2 {
  margin-left: 8px !important;
}
.nkl-mr-2 {
  margin-right: 8px !important;
}
.nkl-mx-2 {
  margin-left: 8px !important;
  margin-right: 8px !important;
}
.nkl-my-2 {
  margin-top: 8px !important;
  margin-bottom: 8px !important;
}
.nkl-m-1 {
  margin: 4px !important;
}
.nkl-mt-1 {
  margin-top: 4px !important;
}
.nkl-mb-1 {
  margin-bottom: 4px !important;
}
.nkl-ml-1 {
  margin-left: 4px !important;
}
.nkl-mr-1 {
  margin-right: 4px !important;
}
.nkl-mx-1 {
  margin-left: 4px !important;
  margin-right: 4px !important;
}
.nkl-my-1 {
  margin-top: 4px !important;
  margin-bottom: 4px !important;
}
.nkl-m-0 {
  margin: 0 !important;
}
.nkl-mt-0 {
  margin-top: 0 !important;
}
.nkl-mb-0 {
  margin-bottom: 0 !important;
}
.nkl-ml-0 {
  margin-left: 0 !important;
}
.nkl-mr-0 {
  margin-right: 0 !important;
}
.nkl-mx-0 {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.nkl-my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.nkl-m-auto {
  margin: auto !important;
}
.nkl-mt-auto {
  margin-top: auto !important;
}
.nkl-mb-auto {
  margin-bottom: auto !important;
}
.nkl-ml-auto {
  margin-left: auto !important;
}
.nkl-mr-auto {
  margin-right: auto !important;
}
.nkl-mx-auto {
  margin-left: auto !important;
  margin-right: auto !important;
}
.nkl-my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}
.nkl-p-5 {
  padding: 24px !important;
}
.nkl-pt-5 {
  padding-top: 24px !important;
}
.nkl-pb-5 {
  padding-bottom: 24px !important;
}
.nkl-pl-5 {
  padding-left: 24px !important;
}
.nkl-pr-5 {
  padding-right: 24px !important;
}
.nkl-px-5 {
  padding-left: 24px !important;
  padding-right: 24px !important;
}
.nkl-py-5 {
  padding-top: 24px !important;
  padding-bottom: 24px !important;
}
.nkl-p-4 {
  padding: 16px !important;
}
.nkl-pt-4 {
  padding-top: 16px !important;
}
.nkl-pb-4 {
  padding-bottom: 16px !important;
}
.nkl-pl-4 {
  padding-left: 16px !important;
}
.nkl-pr-4 {
  padding-right: 16px !important;
}
.nkl-px-4 {
  padding-left: 16px !important;
  padding-right: 16px !important;
}
.nkl-py-4 {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
}
.nkl-p-3 {
  padding: 12px !important;
}
.nkl-pt-3 {
  padding-top: 12px !important;
}
.nkl-pb-3 {
  padding-bottom: 12px !important;
}
.nkl-pl-3 {
  padding-left: 12px !important;
}
.nkl-pr-3 {
  padding-right: 12px !important;
}
.nkl-px-3 {
  padding-left: 12px !important;
  padding-right: 12px !important;
}
.nkl-py-3 {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}
.nkl-p-2 {
  padding: 8px !important;
}
.nkl-pt-2 {
  padding-top: 8px !important;
}
.nkl-pb-2 {
  padding-bottom: 8px !important;
}
.nkl-pl-2 {
  padding-left: 8px !important;
}
.nkl-pr-2 {
  padding-right: 8px !important;
}
.nkl-px-2 {
  padding-left: 8px !important;
  padding-right: 8px !important;
}
.nkl-py-2 {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
.nkl-p-1 {
  padding: 4px !important;
}
.nkl-pt-1 {
  padding-top: 4px !important;
}
.nkl-pb-1 {
  padding-bottom: 4px !important;
}
.nkl-pl-1 {
  padding-left: 4px !important;
}
.nkl-pr-1 {
  padding-right: 4px !important;
}
.nkl-px-1 {
  padding-left: 4px !important;
  padding-right: 4px !important;
}
.nkl-py-1 {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}
.nkl-p-0 {
  padding: 0 !important;
}
.nkl-pt-0 {
  padding-top: 0 !important;
}
.nkl-pb-0 {
  padding-bottom: 0 !important;
}
.nkl-pl-0 {
  padding-left: 0 !important;
}
.nkl-pr-0 {
  padding-right: 0 !important;
}
.nkl-px-0 {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.nkl-py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, "",{"version":3,"sources":["webpack://./node_modules/.pnpm/@nackle+paper@2.9.11_less@4.2.0_prop-types@15.8.1_react-dom@17.0.2_react@17.0.2_webpack@5.93.0_whatwg-fetch@3.6.20/node_modules/@nackle/paper/src/utilities/standalone-entrypoint.less","webpack://./node_modules/.pnpm/@nackle+paper@2.9.11_less@4.2.0_prop-types@15.8.1_react-dom@17.0.2_react@17.0.2_webpack@5.93.0_whatwg-fetch@3.6.20/node_modules/@nackle/paper/src/utilities/color.less","webpack://./node_modules/.pnpm/@nackle+paper@2.9.11_less@4.2.0_prop-types@15.8.1_react-dom@17.0.2_react@17.0.2_webpack@5.93.0_whatwg-fetch@3.6.20/node_modules/@nackle/paper/src/utilities/position.less","webpack://./node_modules/.pnpm/@nackle+paper@2.9.11_less@4.2.0_prop-types@15.8.1_react-dom@17.0.2_react@17.0.2_webpack@5.93.0_whatwg-fetch@3.6.20/node_modules/@nackle/paper/src/utilities/spacing.less"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F;ACH5F;EAAuD,yBAAA;ADMxD;ACLC;EAAuD,qCAAA;ADQxD;ACPC;EAAuD,yBAAA;ADUxD;ACTC;EAAuD,yBAAA;ADYxD;ACXC;;EAAuD,yBAAA;ADexD;ACdC;EAAuD,yBAAA;ADiBxD;AChBC;EAAuD,yBAAA;ADmBxD;AClBC;EAAuD,yBAAA;ADqBxD;ACpBC;EAAuD,sBAAA;ADuBxD;ACtBC;EAAuD,sBAAA;ADyBxD;ACvBC;EAAmD,oCAAA;AD0BpD;ACzBC;EAAmD,gDAAA;AD4BpD;AC3BC;EAAmD,oCAAA;AD8BpD;AC7BC;EAAmD,oCAAA;ADgCpD;AC/BC;;EAAmD,oCAAA;ADmCpD;AClCC;EAAmD,oCAAA;ADqCpD;ACpCC;EAAmD,oCAAA;ADuCpD;ACtCC;EAAmD,oCAAA;ADyCpD;ACxCC;EAAmD,iCAAA;AD2CpD;AC1CC;EAAmD,oCAAA;AD6CpD;AEjEC;EAAkC,6BAAA;AFoEnC;AEnEC;EAAkC,6BAAA;AFsEnC;AErEC;EAAkC,6BAAA;AFwEnC;AEvEC;EAAkC,6BAAA;AF0EnC;AEzEC;EAAkC,6BAAA;AF4EnC;AG7EC;EAAoB,uBAAA;AHgFrB;AG/EC;EAAqB,2BAAA;AHkFtB;AGjFC;EAAqB,8BAAA;AHoFtB;AGnFC;EAAqB,4BAAA;AHsFtB;AGrFC;EAAqB,6BAAA;AHwFtB;AGvFC;EAAqB,4BAAA;EAAoC,6BAAA;AH2F1D;AG1FC;EAAqB,2BAAA;EAAmC,8BAAA;AH8FzD;AG5FC;EAAoB,uBAAA;AH+FrB;AG9FC;EAAqB,2BAAA;AHiGtB;AGhGC;EAAqB,8BAAA;AHmGtB;AGlGC;EAAqB,4BAAA;AHqGtB;AGpGC;EAAqB,6BAAA;AHuGtB;AGtGC;EAAqB,4BAAA;EAAoC,6BAAA;AH0G1D;AGzGC;EAAqB,2BAAA;EAAmC,8BAAA;AH6GzD;AG3GC;EAAoB,uBAAA;AH8GrB;AG7GC;EAAqB,2BAAA;AHgHtB;AG/GC;EAAqB,8BAAA;AHkHtB;AGjHC;EAAqB,4BAAA;AHoHtB;AGnHC;EAAqB,6BAAA;AHsHtB;AGrHC;EAAqB,4BAAA;EAAoC,6BAAA;AHyH1D;AGxHC;EAAqB,2BAAA;EAAmC,8BAAA;AH4HzD;AG1HC;EAAoB,sBAAA;AH6HrB;AG5HC;EAAqB,0BAAA;AH+HtB;AG9HC;EAAqB,6BAAA;AHiItB;AGhIC;EAAqB,2BAAA;AHmItB;AGlIC;EAAqB,4BAAA;AHqItB;AGpIC;EAAqB,2BAAA;EAAoC,4BAAA;AHwI1D;AGvIC;EAAqB,0BAAA;EAAmC,6BAAA;AH2IzD;AGzIC;EAAoB,sBAAA;AH4IrB;AG3IC;EAAqB,0BAAA;AH8ItB;AG7IC;EAAqB,6BAAA;AHgJtB;AG/IC;EAAqB,2BAAA;AHkJtB;AGjJC;EAAqB,4BAAA;AHoJtB;AGnJC;EAAqB,2BAAA;EAAqC,4BAAA;AHuJ3D;AGtJC;EAAqB,0BAAA;EAAoC,6BAAA;AH0J1D;AGxJC;EAAoB,oBAAA;AH2JrB;AG1JC;EAAqB,wBAAA;AH6JtB;AG5JC;EAAqB,2BAAA;AH+JtB;AG9JC;EAAqB,yBAAA;AHiKtB;AGhKC;EAAqB,0BAAA;AHmKtB;AGlKC;EAAqB,yBAAA;EAA2B,0BAAA;AHsKjD;AGrKC;EAAqB,wBAAA;EAA0B,2BAAA;AHyKhD;AGvKC;EAAuB,uBAAA;AH0KxB;AGzKC;EAAwB,2BAAA;AH4KzB;AG3KC;EAAwB,8BAAA;AH8KzB;AG7KC;EAAwB,4BAAA;AHgLzB;AG/KC;EAAwB,6BAAA;AHkLzB;AGjLC;EAAwB,4BAAA;EAA8B,6BAAA;AHqLvD;AGpLC;EAAwB,2BAAA;EAA6B,8BAAA;AHwLtD;AGtLC;EAAoB,wBAAA;AHyLrB;AGxLC;EAAqB,4BAAA;AH2LtB;AG1LC;EAAqB,+BAAA;AH6LtB;AG5LC;EAAqB,6BAAA;AH+LtB;AG9LC;EAAqB,8BAAA;AHiMtB;AGhMC;EAAqB,6BAAA;EAAsC,8BAAA;AHoM5D;AGnMC;EAAqB,4BAAA;EAAqC,+BAAA;AHuM3D;AGrMC;EAAoB,wBAAA;AHwMrB;AGvMC;EAAqB,4BAAA;AH0MtB;AGzMC;EAAqB,+BAAA;AH4MtB;AG3MC;EAAqB,6BAAA;AH8MtB;AG7MC;EAAqB,8BAAA;AHgNtB;AG/MC;EAAqB,6BAAA;EAAsC,8BAAA;AHmN5D;AGlNC;EAAqB,4BAAA;EAAqC,+BAAA;AHsN3D;AGpNC;EAAoB,wBAAA;AHuNrB;AGtNC;EAAqB,4BAAA;AHyNtB;AGxNC;EAAqB,+BAAA;AH2NtB;AG1NC;EAAqB,6BAAA;AH6NtB;AG5NC;EAAqB,8BAAA;AH+NtB;AG9NC;EAAqB,6BAAA;EAAsC,8BAAA;AHkO5D;AGjOC;EAAqB,4BAAA;EAAqC,+BAAA;AHqO3D;AGnOC;EAAoB,uBAAA;AHsOrB;AGrOC;EAAqB,2BAAA;AHwOtB;AGvOC;EAAqB,8BAAA;AH0OtB;AGzOC;EAAqB,4BAAA;AH4OtB;AG3OC;EAAqB,6BAAA;AH8OtB;AG7OC;EAAqB,4BAAA;EAAsC,6BAAA;AHiP5D;AGhPC;EAAqB,2BAAA;EAAqC,8BAAA;AHoP3D;AGlPC;EAAoB,uBAAA;AHqPrB;AGpPC;EAAqB,2BAAA;AHuPtB;AGtPC;EAAqB,8BAAA;AHyPtB;AGxPC;EAAqB,4BAAA;AH2PtB;AG1PC;EAAqB,6BAAA;AH6PtB;AG5PC;EAAqB,4BAAA;EAAuC,6BAAA;AHgQ7D;AG/PC;EAAqB,2BAAA;EAAsC,8BAAA;AHmQ5D;AGjQC;EAAoB,qBAAA;AHoQrB;AGnQC;EAAqB,yBAAA;AHsQtB;AGrQC;EAAqB,4BAAA;AHwQtB;AGvQC;EAAqB,0BAAA;AH0QtB;AGzQC;EAAqB,2BAAA;AH4QtB;AG3QC;EAAqB,0BAAA;EAA4B,2BAAA;AH+QlD;AG9QC;EAAqB,yBAAA;EAA2B,4BAAA;AHkRjD;AACA,4FAA4F;AAC5F,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F","sourcesContent":["/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.nkl-text-primary {\n  color: #1890ff !important;\n}\n.nkl-text-secondary {\n  color: rgba(0, 0, 0, 0.45) !important;\n}\n.nkl-text-success {\n  color: #52c41a !important;\n}\n.nkl-text-processing {\n  color: #1890ff !important;\n}\n.nkl-text-error,\n.nkl-text-danger {\n  color: #ff4d4f !important;\n}\n.nkl-text-warning {\n  color: #faad14 !important;\n}\n.nkl-text-info {\n  color: #1890ff !important;\n}\n.nkl-text-light {\n  color: #d9d9d9 !important;\n}\n.nkl-text-white {\n  color: #fff !important;\n}\n.nkl-text-dark {\n  color: #000 !important;\n}\n.nkl-bg-primary {\n  background-color: #1890ff !important;\n}\n.nkl-bg-secondary {\n  background-color: rgba(0, 0, 0, 0.45) !important;\n}\n.nkl-bg-success {\n  background-color: #52c41a !important;\n}\n.nkl-bg-processing {\n  background-color: #1890ff !important;\n}\n.nkl-bg-error,\n.nkl-bg-danger {\n  background-color: #ff4d4f !important;\n}\n.nkl-bg-warning {\n  background-color: #faad14 !important;\n}\n.nkl-bg-info {\n  background-color: #1890ff !important;\n}\n.nkl-bg-light {\n  background-color: #d9d9d9 !important;\n}\n.nkl-bg-white {\n  background-color: #fff !important;\n}\n.nkl-bg-dark {\n  background-color: #001529 !important;\n}\n.nkl-position-static {\n  position: static   !important;\n}\n.nkl-position-relative {\n  position: relative !important;\n}\n.nkl-position-absolute {\n  position: absolute !important;\n}\n.nkl-position-fixed {\n  position: fixed    !important;\n}\n.nkl-position-sticky {\n  position: sticky   !important;\n}\n.nkl-m-5 {\n  margin: 24px !important;\n}\n.nkl-mt-5 {\n  margin-top: 24px !important;\n}\n.nkl-mb-5 {\n  margin-bottom: 24px !important;\n}\n.nkl-ml-5 {\n  margin-left: 24px !important;\n}\n.nkl-mr-5 {\n  margin-right: 24px !important;\n}\n.nkl-mx-5 {\n  margin-left: 24px !important;\n  margin-right: 24px !important;\n}\n.nkl-my-5 {\n  margin-top: 24px !important;\n  margin-bottom: 24px !important;\n}\n.nkl-m-4 {\n  margin: 16px !important;\n}\n.nkl-mt-4 {\n  margin-top: 16px !important;\n}\n.nkl-mb-4 {\n  margin-bottom: 16px !important;\n}\n.nkl-ml-4 {\n  margin-left: 16px !important;\n}\n.nkl-mr-4 {\n  margin-right: 16px !important;\n}\n.nkl-mx-4 {\n  margin-left: 16px !important;\n  margin-right: 16px !important;\n}\n.nkl-my-4 {\n  margin-top: 16px !important;\n  margin-bottom: 16px !important;\n}\n.nkl-m-3 {\n  margin: 12px !important;\n}\n.nkl-mt-3 {\n  margin-top: 12px !important;\n}\n.nkl-mb-3 {\n  margin-bottom: 12px !important;\n}\n.nkl-ml-3 {\n  margin-left: 12px !important;\n}\n.nkl-mr-3 {\n  margin-right: 12px !important;\n}\n.nkl-mx-3 {\n  margin-left: 12px !important;\n  margin-right: 12px !important;\n}\n.nkl-my-3 {\n  margin-top: 12px !important;\n  margin-bottom: 12px !important;\n}\n.nkl-m-2 {\n  margin: 8px !important;\n}\n.nkl-mt-2 {\n  margin-top: 8px !important;\n}\n.nkl-mb-2 {\n  margin-bottom: 8px !important;\n}\n.nkl-ml-2 {\n  margin-left: 8px !important;\n}\n.nkl-mr-2 {\n  margin-right: 8px !important;\n}\n.nkl-mx-2 {\n  margin-left: 8px !important;\n  margin-right: 8px !important;\n}\n.nkl-my-2 {\n  margin-top: 8px !important;\n  margin-bottom: 8px !important;\n}\n.nkl-m-1 {\n  margin: 4px !important;\n}\n.nkl-mt-1 {\n  margin-top: 4px !important;\n}\n.nkl-mb-1 {\n  margin-bottom: 4px !important;\n}\n.nkl-ml-1 {\n  margin-left: 4px !important;\n}\n.nkl-mr-1 {\n  margin-right: 4px !important;\n}\n.nkl-mx-1 {\n  margin-left: 4px !important;\n  margin-right: 4px !important;\n}\n.nkl-my-1 {\n  margin-top: 4px !important;\n  margin-bottom: 4px !important;\n}\n.nkl-m-0 {\n  margin: 0 !important;\n}\n.nkl-mt-0 {\n  margin-top: 0 !important;\n}\n.nkl-mb-0 {\n  margin-bottom: 0 !important;\n}\n.nkl-ml-0 {\n  margin-left: 0 !important;\n}\n.nkl-mr-0 {\n  margin-right: 0 !important;\n}\n.nkl-mx-0 {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n.nkl-my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n.nkl-m-auto {\n  margin: auto !important;\n}\n.nkl-mt-auto {\n  margin-top: auto !important;\n}\n.nkl-mb-auto {\n  margin-bottom: auto !important;\n}\n.nkl-ml-auto {\n  margin-left: auto !important;\n}\n.nkl-mr-auto {\n  margin-right: auto !important;\n}\n.nkl-mx-auto {\n  margin-left: auto !important;\n  margin-right: auto !important;\n}\n.nkl-my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n.nkl-p-5 {\n  padding: 24px !important;\n}\n.nkl-pt-5 {\n  padding-top: 24px !important;\n}\n.nkl-pb-5 {\n  padding-bottom: 24px !important;\n}\n.nkl-pl-5 {\n  padding-left: 24px !important;\n}\n.nkl-pr-5 {\n  padding-right: 24px !important;\n}\n.nkl-px-5 {\n  padding-left: 24px !important;\n  padding-right: 24px !important;\n}\n.nkl-py-5 {\n  padding-top: 24px !important;\n  padding-bottom: 24px !important;\n}\n.nkl-p-4 {\n  padding: 16px !important;\n}\n.nkl-pt-4 {\n  padding-top: 16px !important;\n}\n.nkl-pb-4 {\n  padding-bottom: 16px !important;\n}\n.nkl-pl-4 {\n  padding-left: 16px !important;\n}\n.nkl-pr-4 {\n  padding-right: 16px !important;\n}\n.nkl-px-4 {\n  padding-left: 16px !important;\n  padding-right: 16px !important;\n}\n.nkl-py-4 {\n  padding-top: 16px !important;\n  padding-bottom: 16px !important;\n}\n.nkl-p-3 {\n  padding: 12px !important;\n}\n.nkl-pt-3 {\n  padding-top: 12px !important;\n}\n.nkl-pb-3 {\n  padding-bottom: 12px !important;\n}\n.nkl-pl-3 {\n  padding-left: 12px !important;\n}\n.nkl-pr-3 {\n  padding-right: 12px !important;\n}\n.nkl-px-3 {\n  padding-left: 12px !important;\n  padding-right: 12px !important;\n}\n.nkl-py-3 {\n  padding-top: 12px !important;\n  padding-bottom: 12px !important;\n}\n.nkl-p-2 {\n  padding: 8px !important;\n}\n.nkl-pt-2 {\n  padding-top: 8px !important;\n}\n.nkl-pb-2 {\n  padding-bottom: 8px !important;\n}\n.nkl-pl-2 {\n  padding-left: 8px !important;\n}\n.nkl-pr-2 {\n  padding-right: 8px !important;\n}\n.nkl-px-2 {\n  padding-left: 8px !important;\n  padding-right: 8px !important;\n}\n.nkl-py-2 {\n  padding-top: 8px !important;\n  padding-bottom: 8px !important;\n}\n.nkl-p-1 {\n  padding: 4px !important;\n}\n.nkl-pt-1 {\n  padding-top: 4px !important;\n}\n.nkl-pb-1 {\n  padding-bottom: 4px !important;\n}\n.nkl-pl-1 {\n  padding-left: 4px !important;\n}\n.nkl-pr-1 {\n  padding-right: 4px !important;\n}\n.nkl-px-1 {\n  padding-left: 4px !important;\n  padding-right: 4px !important;\n}\n.nkl-py-1 {\n  padding-top: 4px !important;\n  padding-bottom: 4px !important;\n}\n.nkl-p-0 {\n  padding: 0 !important;\n}\n.nkl-pt-0 {\n  padding-top: 0 !important;\n}\n.nkl-pb-0 {\n  padding-bottom: 0 !important;\n}\n.nkl-pl-0 {\n  padding-left: 0 !important;\n}\n.nkl-pr-0 {\n  padding-right: 0 !important;\n}\n.nkl-px-0 {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n.nkl-py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n",".@{ant-prefix}-text-primary                           { color: @primary-color !important; }\n.@{ant-prefix}-text-secondary                         { color: @text-color-secondary !important; }\n.@{ant-prefix}-text-success                           { color: @success-color !important; }\n.@{ant-prefix}-text-processing                        { color: @processing-color !important; }\n.@{ant-prefix}-text-error, .@{ant-prefix}-text-danger { color: @error-color !important; }\n.@{ant-prefix}-text-warning                           { color: @warning-color !important; }\n.@{ant-prefix}-text-info                              { color: @info-color !important; }\n.@{ant-prefix}-text-light                             { color: @normal-color !important; }\n.@{ant-prefix}-text-white                             { color: @white !important; }\n.@{ant-prefix}-text-dark                              { color: @black !important; }\n\n.@{ant-prefix}-bg-primary                         { background-color: @primary-color !important; }\n.@{ant-prefix}-bg-secondary                       { background-color: @text-color-secondary !important; }\n.@{ant-prefix}-bg-success                         { background-color: @success-color !important; }\n.@{ant-prefix}-bg-processing                      { background-color: @processing-color !important; }\n.@{ant-prefix}-bg-error, .@{ant-prefix}-bg-danger { background-color: @error-color !important; }\n.@{ant-prefix}-bg-warning                         { background-color: @warning-color !important; }\n.@{ant-prefix}-bg-info                            { background-color: @info-color !important; }\n.@{ant-prefix}-bg-light                           { background-color: @normal-color !important; }\n.@{ant-prefix}-bg-white                           { background-color: @white !important; }\n.@{ant-prefix}-bg-dark                            { background-color: @layout-header-background !important; }\n",".@{ant-prefix}-position-static   { position: static   !important; }\n.@{ant-prefix}-position-relative { position: relative !important; }\n.@{ant-prefix}-position-absolute { position: absolute !important; }\n.@{ant-prefix}-position-fixed    { position: fixed    !important; }\n.@{ant-prefix}-position-sticky   { position: sticky   !important; }\n","// Bootstrap-like utility classes for spacing\n// https://getbootstrap.com/docs/4.0/utilities/spacing/\n\n.@{ant-prefix}-m-5 { margin: @margin-lg !important; }\n.@{ant-prefix}-mt-5 { margin-top: @margin-lg !important; }\n.@{ant-prefix}-mb-5 { margin-bottom: @margin-lg !important; }\n.@{ant-prefix}-ml-5 { margin-left: @margin-lg !important; }\n.@{ant-prefix}-mr-5 { margin-right: @margin-lg !important; }\n.@{ant-prefix}-mx-5 { margin-left: @margin-lg !important; margin-right: @margin-lg !important; }\n.@{ant-prefix}-my-5 { margin-top: @margin-lg !important; margin-bottom: @margin-lg !important; }\n\n.@{ant-prefix}-m-4 { margin: @margin-md !important; }\n.@{ant-prefix}-mt-4 { margin-top: @margin-md !important; }\n.@{ant-prefix}-mb-4 { margin-bottom: @margin-md !important; }\n.@{ant-prefix}-ml-4 { margin-left: @margin-md !important; }\n.@{ant-prefix}-mr-4 { margin-right: @margin-md !important; }\n.@{ant-prefix}-mx-4 { margin-left: @margin-md !important; margin-right: @margin-md !important; }\n.@{ant-prefix}-my-4 { margin-top: @margin-md !important; margin-bottom: @margin-md !important; }\n\n.@{ant-prefix}-m-3 { margin: @margin-sm !important; }\n.@{ant-prefix}-mt-3 { margin-top: @margin-sm !important; }\n.@{ant-prefix}-mb-3 { margin-bottom: @margin-sm !important; }\n.@{ant-prefix}-ml-3 { margin-left: @margin-sm !important; }\n.@{ant-prefix}-mr-3 { margin-right: @margin-sm !important; }\n.@{ant-prefix}-mx-3 { margin-left: @margin-sm !important; margin-right: @margin-sm !important; }\n.@{ant-prefix}-my-3 { margin-top: @margin-sm !important; margin-bottom: @margin-sm !important; }\n\n.@{ant-prefix}-m-2 { margin: @margin-xs !important; }\n.@{ant-prefix}-mt-2 { margin-top: @margin-xs !important; }\n.@{ant-prefix}-mb-2 { margin-bottom: @margin-xs !important; }\n.@{ant-prefix}-ml-2 { margin-left: @margin-xs !important; }\n.@{ant-prefix}-mr-2 { margin-right: @margin-xs !important; }\n.@{ant-prefix}-mx-2 { margin-left: @margin-xs !important; margin-right: @margin-xs !important; }\n.@{ant-prefix}-my-2 { margin-top: @margin-xs !important; margin-bottom: @margin-xs !important; }\n\n.@{ant-prefix}-m-1 { margin: @margin-xss !important; }\n.@{ant-prefix}-mt-1 { margin-top: @margin-xss !important; }\n.@{ant-prefix}-mb-1 { margin-bottom: @margin-xss !important; }\n.@{ant-prefix}-ml-1 { margin-left: @margin-xss !important; }\n.@{ant-prefix}-mr-1 { margin-right: @margin-xss !important; }\n.@{ant-prefix}-mx-1 { margin-left: @margin-xss !important; margin-right: @margin-xss !important; }\n.@{ant-prefix}-my-1 { margin-top: @margin-xss !important; margin-bottom: @margin-xss !important; }\n\n.@{ant-prefix}-m-0 { margin: 0 !important; }\n.@{ant-prefix}-mt-0 { margin-top: 0 !important; }\n.@{ant-prefix}-mb-0 { margin-bottom: 0 !important; }\n.@{ant-prefix}-ml-0 { margin-left: 0 !important; }\n.@{ant-prefix}-mr-0 { margin-right: 0 !important; }\n.@{ant-prefix}-mx-0 { margin-left: 0 !important; margin-right: 0 !important; }\n.@{ant-prefix}-my-0 { margin-top: 0 !important; margin-bottom: 0 !important; }\n\n.@{ant-prefix}-m-auto { margin: auto !important; }\n.@{ant-prefix}-mt-auto { margin-top: auto !important; }\n.@{ant-prefix}-mb-auto { margin-bottom: auto !important; }\n.@{ant-prefix}-ml-auto { margin-left: auto !important; }\n.@{ant-prefix}-mr-auto { margin-right: auto !important; }\n.@{ant-prefix}-mx-auto { margin-left: auto !important; margin-right: auto !important; }\n.@{ant-prefix}-my-auto { margin-top: auto !important; margin-bottom: auto !important; }\n\n.@{ant-prefix}-p-5 { padding: @padding-lg !important; }\n.@{ant-prefix}-pt-5 { padding-top: @padding-lg !important; }\n.@{ant-prefix}-pb-5 { padding-bottom: @padding-lg !important; }\n.@{ant-prefix}-pl-5 { padding-left: @padding-lg !important; }\n.@{ant-prefix}-pr-5 { padding-right: @padding-lg !important; }\n.@{ant-prefix}-px-5 { padding-left: @padding-lg !important; padding-right: @padding-lg !important; }\n.@{ant-prefix}-py-5 { padding-top: @padding-lg !important; padding-bottom: @padding-lg !important; }\n\n.@{ant-prefix}-p-4 { padding: @padding-md !important; }\n.@{ant-prefix}-pt-4 { padding-top: @padding-md !important; }\n.@{ant-prefix}-pb-4 { padding-bottom: @padding-md !important; }\n.@{ant-prefix}-pl-4 { padding-left: @padding-md !important; }\n.@{ant-prefix}-pr-4 { padding-right: @padding-md !important; }\n.@{ant-prefix}-px-4 { padding-left: @padding-md !important; padding-right: @padding-md !important; }\n.@{ant-prefix}-py-4 { padding-top: @padding-md !important; padding-bottom: @padding-md !important; }\n\n.@{ant-prefix}-p-3 { padding: @padding-sm !important; }\n.@{ant-prefix}-pt-3 { padding-top: @padding-sm !important; }\n.@{ant-prefix}-pb-3 { padding-bottom: @padding-sm !important; }\n.@{ant-prefix}-pl-3 { padding-left: @padding-sm !important; }\n.@{ant-prefix}-pr-3 { padding-right: @padding-sm !important; }\n.@{ant-prefix}-px-3 { padding-left: @padding-sm !important; padding-right: @padding-sm !important; }\n.@{ant-prefix}-py-3 { padding-top: @padding-sm !important; padding-bottom: @padding-sm !important; }\n\n.@{ant-prefix}-p-2 { padding: @padding-xs !important; }\n.@{ant-prefix}-pt-2 { padding-top: @padding-xs !important; }\n.@{ant-prefix}-pb-2 { padding-bottom: @padding-xs !important; }\n.@{ant-prefix}-pl-2 { padding-left: @padding-xs !important; }\n.@{ant-prefix}-pr-2 { padding-right: @padding-xs !important; }\n.@{ant-prefix}-px-2 { padding-left: @padding-xs !important; padding-right: @padding-xs !important; }\n.@{ant-prefix}-py-2 { padding-top: @padding-xs !important; padding-bottom: @padding-xs !important; }\n\n.@{ant-prefix}-p-1 { padding: @padding-xss !important; }\n.@{ant-prefix}-pt-1 { padding-top: @padding-xss !important; }\n.@{ant-prefix}-pb-1 { padding-bottom: @padding-xss !important; }\n.@{ant-prefix}-pl-1 { padding-left: @padding-xss !important; }\n.@{ant-prefix}-pr-1 { padding-right: @padding-xss !important; }\n.@{ant-prefix}-px-1 { padding-left: @padding-xss !important; padding-right: @padding-xss !important; }\n.@{ant-prefix}-py-1 { padding-top: @padding-xss !important; padding-bottom: @padding-xss !important; }\n\n.@{ant-prefix}-p-0 { padding: 0 !important; }\n.@{ant-prefix}-pt-0 { padding-top: 0 !important; }\n.@{ant-prefix}-pb-0 { padding-bottom: 0 !important; }\n.@{ant-prefix}-pl-0 { padding-left: 0 !important; }\n.@{ant-prefix}-pr-0 { padding-right: 0 !important; }\n.@{ant-prefix}-px-0 { padding-left: 0 !important; padding-right: 0 !important; }\n.@{ant-prefix}-py-0 { padding-top: 0 !important; padding-bottom: 0 !important; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
